<template>
  <layout>
    <div slot="content">
      <i-card title="添加广告" contentWidth="80%">
        <div slot="content">
          <el-form :model="fields" label-width="80px" :rules="validateRules" size="small">
            <el-form-item label="广告名称" prop="title">
              <el-input v-model="fields.title"></el-input>
            </el-form-item>
            <el-form-item label="广告图片">
              <i-upload v-model="fields.ori_images"></i-upload>
            </el-form-item>
            <el-form-item label="广告位置" prop="position">
              <el-select v-model="fields.position" placeholder="请选择" style="width: 50%">
                <el-option
                  v-for="item in positions"
                  :key="item.position_id"
                  :label="item.label"
                  :value="item.position_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间信息">
              <el-date-picker
                style="width: 50%"
                v-model="fields.date"
                type="datetimerange"
                range-separator="至"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="投放开始时间"
                end-placeholder="投放结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="是否展示" prop="show_status">
              <el-switch v-model="fields.show_status"></el-switch>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" @click="addAds">立即提交</el-button>
              <router-link :to="{name:'settings.ads'}">
                <el-button>返回列表</el-button>
              </router-link>
            </el-form-item>
          </el-form>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
  export default {
    name: "sailings",
    data: function () {
      return {
        loading: false,
        fields: {
          title: '',
          position: '',
          start_time: '',
          end_time: '',
          date: '',
          show_status: true,
          ori_images: [],
          images: []
        },
        validateRules: {
          title: [
            {required: true, message: '广告名称不可为空'}
          ],
          position: [
            {required: true, message: '请选择广告位'}
          ],
          show_status: [
            {required: true, message: '请选择是否需要展示'}
          ]
        },
        timeSelectOption: {
          start: '05:30',
          step: '00:05',
          end: '23:30'
        },
        positions: []
      }
    },
    methods: {
      addAds: function () {
        this.fields.start_time = this.fields.date[0];
        this.fields.end_time = this.fields.date[1];
        this.fields.on_show = this.fields.show_status ? 1 : -1;
        this.fields.images = [];
        this.fields.ori_images.forEach((row) => {
          this.fields.images.push(row.path);
        });
        this.loading = true;
        this.$http.request('postAds', this.fields).then((res) => {
          this.loading = false;
          if (res.status === 'success') {
            this.$message({
              message: res.message, type: 'success', onClose: () => {
                this.$router.push({name: 'settings.ads'});
              }
            });
          }
        });
      },
      getSailings: function () {
        let adsId = this.$route.query.ads_id;
        if (adsId) {
          this.$http.request('adsInfo', {ads_id: adsId}).then((res) => {
            if (res.status === 'success') {
              this.fields = res.data;
            }
          });
        }
      },
      getPositions: function () {
        this.$http.request('adsPosition').then((res) => {
          this.positions = res.data;
        });
      }
    },
    created: function () {
      this.getSailings();
      this.getPositions();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/add_ads.vue